import {
  RequestableState,
  createRequestableState,
  handleDone,
  handleFailed,
  handleStarting,
} from '@tock/shared/state/requestableState';
import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export interface State {
  tockGiftCardPurchase: RequestableState<core.TockGiftCardBalanceResponse>;
  tockGiftCardRedeem: RequestableState<core.TockGiftCardBalanceResponse>;
}

export const initialState: State = {
  tockGiftCardPurchase: createRequestableState<core.TockGiftCardBalanceResponse>(),
  tockGiftCardRedeem: createRequestableState<core.TockGiftCardBalanceResponse>(),
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type } = action;

  switch (type) {
    case AppConstants.TOCK_GIFT_CARD_CLEAR: {
      return {
        ...initialState,
      };
    }
    case AppConstants.TOCK_GIFT_CARD_PURCHASE_STARTING: {
      return {
        ...state,
        tockGiftCardPurchase: handleStarting(state.tockGiftCardPurchase, action),
      };
    }
    case AppConstants.TOCK_GIFT_CARD_PURCHASE_DONE: {
      return {
        ...state,
        tockGiftCardPurchase: handleDone(state.tockGiftCardPurchase, action),
      };
    }
    case AppConstants.TOCK_GIFT_CARD_PURCHASE_FAILED: {
      return {
        ...state,
        tockGiftCardPurchase: handleFailed(state.tockGiftCardPurchase, action),
      };
    }
    case AppConstants.TOCK_GIFT_CARD_REDEEM_STARTING: {
      return {
        ...state,
        tockGiftCardRedeem: handleStarting(state.tockGiftCardRedeem, action),
      };
    }
    case AppConstants.TOCK_GIFT_CARD_REDEEM_DONE: {
      return {
        ...state,
        tockGiftCardRedeem: handleDone(state.tockGiftCardRedeem, action),
      };
    }
    case AppConstants.TOCK_GIFT_CARD_REDEEM_FAILED: {
      return {
        ...state,
        tockGiftCardRedeem: handleFailed(state.tockGiftCardRedeem, action),
      };
    }
    default:
      return state;
  }
}
